import actionType from './actionType';
import initialState from './initialState';

const calculationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_CALCULATION_FIELD_SUCCESS:
            return {
                ...state,
                calculationFieldQuery: action.payload.length > 0 ? action.payload[0] : null,
            };
        case actionType.GET_CALCULATION_FILTER_SUCCESS:
            return {
                ...state,
                calculationFilter: action.payload,
            };
        default:
            return state;
    }
};


export default calculationReducer;
